// // export const arr={
// //     "select_plan": "Choisissez votre forfait",
// //     "DISCOVER AMAZING RECIPES":"DECOUVREZ D'INCROYABLES RECETTES",
// //     "DISCOVER":"DÉCOUVRIR",
// //     "INCREDIBLE":"D'INCROYABLE",
// //     "RECIPES":"RECETTES",
// //     "Share your culinary creations and explore recipes from chefs around the world.":"Partagez vos créations culinaires et découvrez des recettes de chefs du monde entier.",
// //     "Recipes":"Recettes",
// //     "recipes":"recettes",
// //     "Instructions":"Instructions",
// //     "Ingredients":"Ingrédients",
// //     "Share Recipe":"Partager la recette",
// //     "Easy to follow ingredients and cooking instructions.":"Ingrédients et instructions de cuisson faciles à suivre.",
// //     "recipes available":"recettes disponibles",
// //     "Browse by Category":"Parcourir par catégorie",
// //     "Avg. Cook Time":"Temps moyen de préparation",
// //     "Discover Incredible Recipes":"Découvrez d'incroyables recettes",
// //     "User Rating":"Note des utilisateurs",
// //     "Enter your mobile number (MSISDN)":"Entrez votre numéro de mobile (MSISDN)",
// //     "Enter exactly 9 digits (e.g. 650123456)":"Saisissez exactement 9 chiffres (ex. : 650123456)",
// //     "SUBSCRIBE":"S’ABONNER",
// //     "By subscribing, you agree to our":"En vous abonnant, vous acceptez nos conditions générales.",
// //     "Terms & Conditions":"Conditions générales",
// //     "Step-by-Step Instructions":"Instructions étape par étape",
// //     "Save Your Favorites":"Enregistrez vos favoris",
// //     "Smart Grocery List":"Liste de courses intelligente",
// //     "Delicious starts here":"Le plaisir commence ici",
// //     "Enter 9 digit number":"Entrez un numéro à 9 chiffres",
// //     "Please enter a valid 9-digit Cameroon mobile number.":"Veuillez saisir un numéro de mobile camerounais valide à 9 chiffres.",
// //     "Verify Your Number":"Vérifiez votre numéro",
// //     "Enter the verification code sent to your mobile number":"Saisissez le code de vérification envoyé à votre numéro de mobile.",
// //     "One-Time Password (OTP)":"Mot de passe à usage unique (OTP)",
// //     "Verify & Proceed":"Vérifier et continuer",
// //     "Didn't receive the code?":"Vous n’avez pas reçu le code ?",
// //     "Resend available in":"Nouvel envoi disponible dans",
// //     "Resend OTP":"Renvoyer l’OTP",
// //     "Back":"Retour",
// //     "STEP 1 OF 2":"ÉTAPE 1 SUR 2",
// //     "Your Perfect Meal Starts Here":"Votre repas parfait commence ici",
// //     "Choose between a recurring meal plan or a one-time food order. Fresh, delicious meals delivered to your doorstep.":"Choisissez entre un abonnement de repas récurrent ou une commande ponctuelle. Des repas frais et délicieux livrés directement à votre porte.",
// //     "Your Number":"Votre numéro",
// //     "OTP":"OTP",
// //     "Pack Type":"Type de pack",
// //     "Choose Plan":"Choisir un forfait",
// //     "SUBSCRIPTION PACKS (MOST POPULAR)":"PACKS D’ABONNEMENT (LE PLUS POPULAIRE)",
// //     "Daily fresh meals delivered automatically":"Des repas frais livrés automatiquement chaque jour",
// //     "Auto Renewal":"Renouvellement automatique",
// //     "Hassle-free and convenient":"Simple et pratique",
// //     "Better Value":"Meilleur rapport qualité-prix",
// //     "Save more with every plan":"Économisez davantage avec chaque abonnement",
// //     "Never Miss a Meal":" Ne manquez jamais un repas",
// //     "Meals delivered on your schedule":"Repas livrés selon votre planning",
// //     "OR":"OU",
// //     "ONE-TIME ORDER":"COMMANDE PONCTUELLE",
// //     "Order whenever you want":"Commandez quand vous le souhaitez",
// //     "No Commitment":" Sans engagement",
// //     "Pay only when you order":"Payez uniquement lorsque vous commandez",
// //     "Instant Purchase":"Achat instantané",
// //     "Quick and easy checkout":"Paiement rapide et facile",
// //     "Flexible Choice":"Choix flexible",
// //     "Order what you want, when you want":"Commandez ce que vous voulez, quand vous voulez",
// //     "Continue":"Continuer",
// //     "SUBSCRIPTION PACKS":"Formules d'abonnement",
// //     "Your":"Ton",
// //     "Perfect Meal":"Repas parfait",
// //     "Starts Here":"Ça commence ici",
// //      "MOST POPULAR":"LES PLUS POPULAIRES",
// //     "ONE-TIME PURCHASE OFFER":"Offre d'achat unique",
// //     "Choose Your Perfect Meal Pack ":"Choisissez votre pack repas idéal",
// //     "Select the pack size and serving amount that best fits your recurring meal needs.":"Sélectionnez la taille du pack et la quantité de portions qui correspondent le mieux à vos besoins en repas récurrents.",
// //     "DAILY PLAN":"FORFAIT QUOTIDIEN",
// //     "UVFOODBOX / Day":"UVFOODBOX / jour",
// //      "day":"jour",
// //     "Perfect for daily meal enjoyment":"Parfait pour profiter de repas frais chaque jour",
// //     "Select Plan":"Sélectionner le forfait",
// //      "WEEKLY PLAN":"FORFAIT HEBDOMADAIRE",
// //     "UVFOODBOX / Week":"UVFOODBOX / Semaine",
// //     "week":"semaine",
// //     "Best value for the week":"Le meilleur rapport qualité-prix pour la semaine",
// //     "Select Plan":"Sélectionner le forfait",
// //     "Choose Your":"Choisissez votre",
// //      "Perfect Meal Pack":"Pack repas idéal",
// //     "Select the pack size and serving amount that best fits your":"Sélectionnez la taille du paquet et la quantité par portion qui correspondent le mieux à vos",
// //     "recurring meal":"repas récurrent",
// //      "one-time order":"commande ponctuelle",
// //     "XAF / day":"XAF / jour",
// //     "XAF / week":"XAF / semaine",
// //      "STEP 2 OF 2":"ÉTAPE 2 SUR 2",
// //     "Verify OTP":"Vérifier le code OTP",
// //     "Discover Delicious":"Découvrez le délicieux",
// //      "Recipes":"Recettes",
// //     "Unlock delicious recipes, cooking tips, and meal ideas to inspire your next dish.":"Découvrez de délicieuses recettes, des astuces de cuisine et des idées de repas pour inspirer votre prochain plat.",
// //     "Unlimited access to premium recipes":"Accès illimité aux recettes premium",
// //      "Unlimited Recipes":"Recette illimitée",
// //     "Access our complete recipe collection":"Accédez à notre collection complète de recettes",
// //     "Learn techniques from expert chefs":"Apprenez des techniques auprès de chefs experts.",
// //      "Premium Cooking Tips":"Conseils culinaires de premier choix",
// //     "Get instant access to selected recipes":"Accédez instantanément à une sélection de recettes.",
// //     "Pay once only":"Payez une seule fois",
// //     "Purchase only what you need":"N'achetez que ce dont vous avez besoin.",
// //     "Start cooking immediately":"Commencez à cuisiner immédiatement.",
// //     "Recipe Collection":" collection de recettes",
// //      "Choose the perfect recipe plan and start cooking today.":"Choisissez la formule de recettes idéale et commencez à cuisiner dès aujourd'hui.",
// //     "Unlock a full week of recipe inspiration":"Découvrez une semaine entière d'inspiration culinaire",
// //     "Discover fresh recipes every day":"Découvrez de nouvelles recettes chaque jour",
// //      "Enjoy recipes for an entire week":"Profitez de recettes pour toute une semaine.",
// //     "Explore recipes for one day":"Découvrez des recettes pour une journée",
// //     "Choose Pack":"Choisir un pack",
// //      "Your purchase has been completed successfully":"Votre achat a été effectué avec succès.",
// //     "Thank you for choosing":"Merci d'avoir choisi",
// //     "Click the button below to start enjoying delicious meals delivered directly to your doorstep.":"Cliquez sur le bouton ci-dessous pour commencer à profiter de délicieux repas livrés directement à votre porte.",
// //      "Click here":"Cliquez ici",
// //     "XAF / week":"XAF / semaine",
// //     "XAF / day":"XAF / jour",
// //      "Click the button below to start exploring delicious recipes and cooking inspiration.":"Cliquez sur le bouton ci-dessous pour commencer à découvrir de délicieuses recettes et trouver l'inspiration en cuisine.",
// //     "Home":"Maison",
// //     "Categories":"Catégories",
// //      "Discover, share, and create amazing recipes from around the world.":"Découvrez, partagez et créez des recettes incroyables venues du monde entier.",
// //     "All rights reserved.":"Tous droits réservés.",
// //     "steps":"mesures",
// //     "About Us":"À propos de nous",
// //     "Submit Recipe":"Soumettre une recette",
// //     "My Profile":"Mon profil",
// //      "Share Your Recipe":"Partagez votre recette",
// //     "Fill in the details below to publish your recipe to the community":"Remplissez les informations ci-dessous pour publier votre recette auprès de la communauté.",
// //     "New Recipe":"Nouvelle recette",
// //      "Recipe Photo":"Photo de la recette",
// //     "Video URL (optional)":"URL de la vidéo (facultatif)",
// //     "Basic Info":"Informations de base",
// //      "Recipe Name":"Nom de la recette",
// //     "Description":"Description",
// //     "Category":"Catégorie",
// //      "Time & Servings":"Temps et portions",
// //     "Prep Time (min)":"Temps de préparation (min)",
// //     "Cook Time (min)":"Temps de cuisson (min)",
// //      "Servings":"Portions",
// //     "Classification":"Classification",
// //     "Click to upload a photo":"Cliquez pour télécharger une photo",
// //     "Classification":"Classification",
// // "Difficulty":"Difficulté",
// // "Easy":"Facile",
// // "Medium":"Moyen",
// // "Hard":"Difficile",
// // "Meal Type":"Type de repas",
// // "Breakfast":"Petit-déjeuner",
// // "Lunch":"Déjeuner",
// // "Dinner":"Dîner",
// // "Snack":"En-cas",
// // "Dessert":"Dessert",
 
// // "Diet Type":"Type de régime",
// // "Veg":        "Végétarien",
// // "Non Veg":"Non végétarien",
// // "Vegan":"Végétalien",
// // "Keto": "Cétogène",
// // "Low Carb": "Faible en glucides",
// // "High Protein":"Riche en protéines",
 
// // "Ingredients":"Ingrédients",
 
// // "Ingredient":"Ingrédient",
// // "e.g. chicken breast":"ex. : blanc de poulet",
// // "Quantity":"Quantité",
// // "e.g. 2 cups":"ex. : 2 tasses",
// // "Add Ingredient":"Ajouter un ingrédient",
 
 
// // "Preparation Steps":"Étapes de préparation",
 
// // "Step 1: describe what to do...":"Étape 1 : décrivez ce qu'il faut faire...",
// // "Add Step":"Ajouter une étape",
// // "Publishing":"Publication",
// // "Feature this recipe":"Mettre cette recette en avant",
// // "Featured recipes appear on the homepage":"Les recettes mises en avant apparaissent sur la page d'accueil",
 
// // "Status":"Statut",
 
 
// // "Active — visible to everyone":"Actif — visible par tous",
 
// // "Inactive — hidden from listing":"Inactif — masqué dans la liste",
 
 
// // "Publish Recipe":"Publier la recette",
// // "All rights reserved":"Tous droits réservés",
// // "Cancel":"Annuler",
// // "Yes, Deactivate":"Oui, désactiver",
// // "Deactivating...":"Désactivation en cours...",
// // "This will deactivate your account and you'll lose access until you resubscribe. This action cannot be undone":"Cela désactivera votre compte et vous en perdrez l'accès jusqu'à ce que vous vous réabonniez. Cette action est irréversible.",
// // "Deactivate Account":"Désactiver le compte",
// // "Your Name":"Votre nom",
// // "Some Error Occured While Deactivation!!":"Une erreur s'est produite lors de la désactivation !!",
// // "User Deactivated Successfully!!":"Utilisateur désactivé avec succès !!",
// // "subscribing...":"s'abonner...",
// // "Please top up your account to continue using the service.":"Veuillez recharger votre compte pour continuer à utiliser le service.",
// // "Payment Failed!!":"Échec du paiement !!",
// // "OTP Verification Failed!!":"Échec de la vérification du code OTP !!",
// // "Failed to send OTP!!":"Échec de l'envoi du code OTP !!",
// // "Wrong Otp Entered!":"Code OTP incorrect !",
// // "Otp Verified Successfully":"OTP vérifié avec succès"

// // }



// export const arr={
//     "select_plan": "اختر باقتك",
//     "DISCOVER AMAZING RECIPES":"اكتشف وصفات رائعة",
//     "DISCOVER":"اكتشف",
//     "INCREDIBLE":"مذهلة",
//     "RECIPES":"وصفات",
//     "Share your culinary creations and explore recipes from chefs around the world.":"شارك إبداعاتك الطهوية واستكشف وصفات من طهاة حول العالم.",
//     "Recipes":"وصفات",
//     "recipes":"وصفات",
//     "Instructions":"التعليمات",
//     "Ingredients":"المكونات",
//     "Share Recipe":"شارك الوصفة",
//     "Easy to follow ingredients and cooking instructions.":"مكونات وتعليمات طهي سهلة الاتباع.",
//     "recipes available":"وصفة متاحة",
//     "Browse by Category":"تصفح حسب الفئة",
//     "Avg. Cook Time":"متوسط وقت الطهي",
//     "Discover Incredible Recipes":"اكتشف وصفات مذهلة",
//     "User Rating":"تقييم المستخدمين",
//     "Enter your mobile number (MSISDN)":"أدخل رقم هاتفك المحمول (MSISDN)",
//     "Enter exactly 9 digits (e.g. 650123456)":"أدخل 9 أرقام بالضبط (مثال: 650123456)",
//     "SUBSCRIBE":"اشترك",
//     "By subscribing, you agree to our":"بالاشتراك، فإنك توافق على شروطنا وأحكامنا.",
//     "Terms & Conditions":"الشروط والأحكام",
//     "Step-by-Step Instructions":"تعليمات خطوة بخطوة",
//     "Save Your Favorites":"احفظ المفضلة لديك",
//     "Smart Grocery List":"قائمة تسوق ذكية",
//     "Delicious starts here":"الطعم اللذيذ يبدأ من هنا",
//     "Enter 9 digit number":"أدخل رقمًا مكونًا من 9 أرقام",
//     "Please enter a valid 9-digit Cameroon mobile number.":"يرجى إدخال رقم هاتف محمول كاميروني صالح مكون من 9 أرقام.",
//     "Verify Your Number":"تحقق من رقمك",
//     "Enter the verification code sent to your mobile number":"أدخل رمز التحقق المُرسَل إلى رقم هاتفك المحمول.",
//     "One-Time Password (OTP)":"كلمة المرور لمرة واحدة (OTP)",
//     "Verify & Proceed":"تحقق وتابع",
//     "Didn't receive the code?":"لم تستلم الرمز؟",
//     "Resend available in":"إعادة الإرسال متاحة خلال",
//     "Resend OTP":"إعادة إرسال الرمز",
//     "Back":"رجوع",
//     "STEP 1 OF 2":"الخطوة 1 من 2",
//     "Your Perfect Meal Starts Here":"وجبتك المثالية تبدأ من هنا",
//     "Choose between a recurring meal plan or a one-time food order. Fresh, delicious meals delivered to your doorstep.":"اختر بين اشتراك وجبات متكرر أو طلب طعام لمرة واحدة. وجبات طازجة ولذيذة تُوصَّل إلى باب منزلك.",
//     "Your Number":"رقمك",
//     "OTP":"رمز التحقق",
//     "Pack Type":"نوع الباقة",
//     "Choose Plan":"اختر الخطة",
//     "SUBSCRIPTION PACKS (MOST POPULAR)":"باقات الاشتراك (الأكثر شعبية)",
//     "Daily fresh meals delivered automatically":"وجبات طازجة تُوصَّل تلقائيًا يوميًا",
//     "Auto Renewal":"تجديد تلقائي",
//     "Hassle-free and convenient":"سهل ومريح بدون عناء",
//     "Better Value":"قيمة أفضل",
//     "Save more with every plan":"وفّر أكثر مع كل خطة",
//     "Never Miss a Meal":"لا تفوّت أي وجبة",
//     "Meals delivered on your schedule":"وجبات تُوصَّل حسب جدولك",
//     "OR":"أو",
//     "ONE-TIME ORDER":"طلب لمرة واحدة",
//     "Order whenever you want":"اطلب متى شئت",
//     "No Commitment":"بدون التزام",
//     "Pay only when you order":"ادفع فقط عند الطلب",
//     "Instant Purchase":"شراء فوري",
//     "Quick and easy checkout":"إتمام الشراء بسرعة وسهولة",
//     "Flexible Choice":"خيار مرن",
//     "Order what you want, when you want":"اطلب ما تريد، وقتما تريد",
//     "Continue":"متابعة",
//     "SUBSCRIPTION PACKS":"باقات الاشتراك",
//     "Your":"وجبتك",
//     "Perfect Meal":"المثالية",
//     "Starts Here":"تبدأ من هنا",
//      "MOST POPULAR":"الأكثر شعبية",
//     "ONE-TIME PURCHASE OFFER":"عرض شراء لمرة واحدة",
//     "Choose Your Perfect Meal Pack ":"اختر باقة وجبتك المثالية",
//     "Select the pack size and serving amount that best fits your recurring meal needs.":"اختر حجم الباقة وكمية الحصص التي تناسب احتياجاتك من الوجبات المتكررة.",
//     "DAILY PLAN":"الخطة اليومية",
//     "UVFOODBOX / Day":"UVFOODBOX / يوم",
//      "day":"يوم",
//     "Perfect for daily meal enjoyment":"مثالية للاستمتاع بالوجبات يوميًا",
//     "Select Plan":"اختر الخطة",
//      "WEEKLY PLAN":"الخطة الأسبوعية",
//     "UVFOODBOX / Week":"UVFOODBOX / أسبوع",
//     "week":"أسبوع",
//     "Best value for the week":"أفضل قيمة للأسبوع",
//     "Choose Your":"اختر",
//      "Perfect Meal Pack":"باقة الوجبة المثالية",
//     "Select the pack size and serving amount that best fits your":"اختر حجم الباقة وكمية الحصص التي تناسب",
//     "recurring meal":"الوجبات المتكررة",
//      "one-time order":"الطلب لمرة واحدة",
//     "XAF / day":"فرنك أفريقي / يوم",
//     "XAF / week":"فرنك أفريقي / أسبوع",
//      "STEP 2 OF 2":"الخطوة 2 من 2",
//     "Verify OTP":"تحقق من الرمز",
//     "Discover Delicious":"اكتشف اللذيذ",
//     "Unlock delicious recipes, cooking tips, and meal ideas to inspire your next dish.":"اكتشف وصفات لذيذة ونصائح طهي وأفكار وجبات تلهم طبقك القادم.",
//     "Unlimited access to premium recipes":"وصول غير محدود إلى الوصفات المميزة",
//      "Unlimited Recipes":"وصفات غير محدودة",
//     "Access our complete recipe collection":"استفد من مجموعتنا الكاملة من الوصفات",
//     "Learn techniques from expert chefs":"تعلّم تقنيات من طهاة خبراء.",
//      "Premium Cooking Tips":"نصائح طهي مميزة",
//     "Get instant access to selected recipes":"احصل على وصول فوري لوصفات مختارة.",
//     "Pay once only":"ادفع مرة واحدة فقط",
//     "Purchase only what you need":"اشترِ فقط ما تحتاجه.",
//     "Start cooking immediately":"ابدأ الطهي فورًا.",
//     "Recipe Collection":"مجموعة الوصفات",
//      "Choose the perfect recipe plan and start cooking today.":"اختر خطة الوصفات المثالية وابدأ الطهي اليوم.",
//     "Unlock a full week of recipe inspiration":"احصل على أسبوع كامل من إلهام الوصفات",
//     "Discover fresh recipes every day":"اكتشف وصفات جديدة كل يوم",
//      "Enjoy recipes for an entire week":"استمتع بالوصفات لأسبوع كامل.",
//     "Explore recipes for one day":"استكشف وصفات ليوم واحد",
//     "Choose Pack":"اختر الباقة",
//      "Your purchase has been completed successfully":"تمت عملية الشراء بنجاح.",
//     "Thank you for choosing":"شكرًا لاختيارك",
//     "Click the button below to start enjoying delicious meals delivered directly to your doorstep.":"انقر على الزر أدناه لتبدأ الاستمتاع بوجبات لذيذة تُوصَّل مباشرة إلى باب منزلك.",
//      "Click here":"انقر هنا",
//     "Click the button below to start exploring delicious recipes and cooking inspiration.":"انقر على الزر أدناه لتبدأ استكشاف وصفات لذيذة وإلهام في الطهي.",
//     "Home":"الرئيسية",
//     "Categories":"الفئات",
//      "Discover, share, and create amazing recipes from around the world.":"اكتشف وشارك وابتكر وصفات رائعة من جميع أنحاء العالم.",
//     "All rights reserved.":"جميع الحقوق محفوظة.",
//     "steps":"خطوات",
//     "About Us":"من نحن",
//     "Submit Recipe":"أرسل وصفة",
//     "My Profile":"ملفي الشخصي",
//      "Share Your Recipe":"شارك وصفتك",
//     "Fill in the details below to publish your recipe to the community":"املأ التفاصيل أدناه لنشر وصفتك للمجتمع.",
//     "New Recipe":"وصفة جديدة",
//      "Recipe Photo":"صورة الوصفة",
//     "Video URL (optional)":"رابط الفيديو (اختياري)",
//     "Basic Info":"معلومات أساسية",
//      "Recipe Name":"اسم الوصفة",
//     "Description":"الوصف",
//     "Category":"الفئة",
//      "Time & Servings":"الوقت والحصص",
//     "Prep Time (min)":"وقت التحضير (دقيقة)",
//     "Cook Time (min)":"وقت الطهي (دقيقة)",
//      "Servings":"عدد الحصص",
//     "Classification":"التصنيف",
//     "Click to upload a photo":"انقر لتحميل صورة",
// "Difficulty":"مستوى الصعوبة",
// "Easy":"سهل",
// "Medium":"متوسط",
// "Hard":"صعب",
// "Meal Type":"نوع الوجبة",
// "Breakfast":"فطور",
// "Lunch":"غداء",
// "Dinner":"عشاء",
// "Snack":"وجبة خفيفة",
// "Dessert":"حلوى",
 
// "Diet Type":"نوع النظام الغذائي",
// "Veg":"نباتي",
// "Non Veg":"غير نباتي",
// "Vegan":"نباتي صرف",
// "Keto":"كيتو",
// "Low Carb":"قليل الكربوهيدرات",
// "High Protein":"غني بالبروتين",
 
// "Ingredient":"المكون",
// "e.g. chicken breast":"مثال: صدر دجاج",
// "Quantity":"الكمية",
// "e.g. 2 cups":"مثال: كوبان",
// "Add Ingredient":"أضف مكونًا",
 
 
// "Preparation Steps":"خطوات التحضير",
 
// "Step 1: describe what to do...":"الخطوة 1: صف ما يجب فعله...",
// "Add Step":"أضف خطوة",
// "Publishing":"النشر",
// "Feature this recipe":"إبراز هذه الوصفة",
// "Featured recipes appear on the homepage":"تظهر الوصفات المميزة في الصفحة الرئيسية",
 
// "Status":"الحالة",
 
 
// "Active — visible to everyone":"نشط — مرئي للجميع",
 
// "Inactive — hidden from listing":"غير نشط — مخفي من القائمة",
 
 
// "Publish Recipe":"انشر الوصفة",
// "All rights reserved":"جميع الحقوق محفوظة",
// "Cancel":"إلغاء",
// "Yes, Deactivate":"نعم، قم بالتعطيل",
// "Deactivating...":"جارٍ التعطيل...",
// "This will deactivate your account and you'll lose access until you resubscribe. This action cannot be undone":"سيؤدي هذا إلى تعطيل حسابك وستفقد الوصول إليه حتى تشترك مجددًا. لا يمكن التراجع عن هذا الإجراء.",
// "Deactivate Account":"تعطيل الحساب",
// "Your Name":"اسمك",
// "Some Error Occured While Deactivation!!":"حدث خطأ أثناء التعطيل!!",
// "User Deactivated Successfully!!":"تم تعطيل المستخدم بنجاح!!",
// "subscribing...":"جارٍ الاشتراك...",
// "Please top up your account to continue using the service.":"يرجى شحن حسابك لمتابعة استخدام الخدمة.",
// "Payment Failed!!":"فشلت عملية الدفع!!",
// "OTP Verification Failed!!":"فشل التحقق من الرمز!!",
// "Failed to send OTP!!":"فشل إرسال الرمز!!",
// "Wrong Otp Entered!":"تم إدخال رمز خاطئ!",
// "Otp Verified Successfully":"تم التحقق من الرمز بنجاح"

// }
















const ar = {
  "select_plan": "اختر باقتك",
  "DISCOVER AMAZING RECIPES": "اكتشف وصفات رائعة",
  "DISCOVER": "اكتشف",
  "INCREDIBLE": "مذهلة",
  "RECIPES": "وصفات",
  "Share your culinary creations and explore recipes from chefs around the world.": "شارك إبداعاتك الطهوية واستكشف وصفات من طهاة حول العالم.",
  "Recipes": "وصفات",
  "recipes": "وصفات",
  "Instructions": "التعليمات",
  "Ingredients": "المكونات",
  "Share Recipe": "شارك الوصفة",
  "Easy to follow ingredients and cooking instructions.": "مكونات وتعليمات طهي سهلة الاتباع.",
  "recipes available": "وصفة متاحة",
  "Browse by Category": "تصفح حسب الفئة",
  "Avg. Cook Time": "متوسط وقت الطهي",
  "Discover Incredible Recipes": "اكتشف وصفات مذهلة",
  "User Rating": "تقييم المستخدمين",
  "Enter your mobile number (MSISDN)": "أدخل رقم هاتفك المحمول (MSISDN)",
  "Enter exactly 9 digits (e.g. 650123456)": "أدخل 9 أرقام بالضبط (مثال: 650123456)",
  "SUBSCRIBE": "اشترك",
  "By subscribing, you agree to our": "بالاشتراك، فإنك توافق على شروطنا وأحكامنا.",
  "Terms & Conditions": "الشروط والأحكام",
  "Step-by-Step Instructions": "تعليمات خطوة بخطوة",
  "Save Your Favorites": "احفظ المفضلة لديك",
  "Smart Grocery List": "قائمة تسوق ذكية",
  "Delicious starts here": "الطعم اللذيذ يبدأ من هنا",
  "Enter 9 digit number": "أدخل رقمًا مكونًا من 9 أرقام",
  "Please enter a valid 9-digit Cameroon mobile number.": "يرجى إدخال رقم هاتف محمول كاميروني صالح مكون من 9 أرقام.",
  "Verify Your Number": "تحقق من رقمك",
  "Enter the verification code sent to your mobile number": "أدخل رمز التحقق المُرسَل إلى رقم هاتفك المحمول.",
  "One-Time Password (OTP)": "كلمة المرور لمرة واحدة (OTP)",
  "Verify & Proceed": "تحقق وتابع",
  "Didn't receive the code?": "لم تستلم الرمز؟",
  "Resend available in": "إعادة الإرسال متاحة خلال",
  "Resend OTP": "إعادة إرسال الرمز",
  "Back": "رجوع",
  "STEP 1 OF 2": "الخطوة 1 من 2",
  "Your Perfect Meal Starts Here": "وجبتك المثالية تبدأ من هنا",
  "Choose between a recurring meal plan or a one-time food order. Fresh, delicious meals delivered to your doorstep.": "اختر بين اشتراك وجبات متكرر أو طلب طعام لمرة واحدة. وجبات طازجة ولذيذة تُوصَّل إلى باب منزلك.",
  "Your Number": "رقمك",
  "OTP": "رمز التحقق",
  "Pack Type": "نوع الباقة",
  "Choose Plan": "اختر الخطة",
  "SUBSCRIPTION PACKS (MOST POPULAR)": "باقات الاشتراك (الأكثر شعبية)",
  "Daily fresh meals delivered automatically": "وجبات طازجة تُوصَّل تلقائيًا يوميًا",
  "Auto Renewal": "تجديد تلقائي",
  "Hassle-free and convenient": "سهل ومريح بدون عناء",
  "Better Value": "قيمة أفضل",
  "Save more with every plan": "وفّر أكثر مع كل خطة",
  "Never Miss a Meal": "لا تفوّت أي وجبة",
  "Meals delivered on your schedule": "وجبات تُوصَّل حسب جدولك",
  "OR": "أو",
  "ONE-TIME ORDER": "طلب لمرة واحدة",
  "Order whenever you want": "اطلب متى شئت",
  "No Commitment": "بدون التزام",
  "Pay only when you order": "ادفع فقط عند الطلب",
  "Instant Purchase": "شراء فوري",
  "Quick and easy checkout": "إتمام الشراء بسرعة وسهولة",
  "Flexible Choice": "خيار مرن",
  "Order what you want, when you want": "اطلب ما تريد، وقتما تريد",
  "Continue": "متابعة",
  "SUBSCRIPTION PACKS": "باقات الاشتراك",
  "Your": "وجبتك",
  "Perfect Meal": "المثالية",
  "Starts Here": "تبدأ من هنا",
  "MOST POPULAR": "الأكثر شعبية",
  "ONE-TIME PURCHASE OFFER": "عرض شراء لمرة واحدة",
  "Choose Your Perfect Meal Pack ": "اختر باقة وجبتك المثالية",
  "Select the pack size and serving amount that best fits your recurring meal needs.": "اختر حجم الباقة وكمية الحصص التي تناسب احتياجاتك من الوجبات المتكررة.",
  "DAILY PLAN": "الخطة اليومية",
  "UVFOODBOX / Day": "UVFOODBOX / يوم",
  "day": "يوم",
  "Perfect for daily meal enjoyment": "مثالية للاستمتاع بالوجبات يوميًا",
  "Select Plan": "اختر الخطة",
  "WEEKLY PLAN": "الخطة الأسبوعية",
  "UVFOODBOX / Week": "UVFOODBOX / أسبوع",
  "week": "أسبوع",
  "Best value for the week": "أفضل قيمة للأسبوع",
  "Choose Your": "اختر",
  "Perfect Meal Pack": "باقة الوجبة المثالية",
  "Select the pack size and serving amount that best fits your": "اختر حجم الباقة وكمية الحصص التي تناسب",
  "recurring meal": "الوجبات المتكررة",
  "one-time order": "الطلب لمرة واحدة",
  "XAF / day": "فرنك أفريقي / يوم",
  "XAF / week": "فرنك أفريقي / أسبوع",
  "STEP 2 OF 2": "الخطوة 2 من 2",
  "Verify OTP": "تحقق من الرمز",
  "Discover Delicious": "اكتشف اللذيذ",
  "Unlock delicious recipes, cooking tips, and meal ideas to inspire your next dish.": "اكتشف وصفات لذيذة ونصائح طهي وأفكار وجبات تلهم طبقك القادم.",
  "Unlimited access to premium recipes": "وصول غير محدود إلى الوصفات المميزة",
  "Unlimited Recipes": "وصفات غير محدودة",
  "Access our complete recipe collection": "استفد من مجموعتنا الكاملة من الوصفات",
  "Learn techniques from expert chefs": "تعلّم تقنيات من طهاة خبراء.",
  "Premium Cooking Tips": "نصائح طهي مميزة",
  "Get instant access to selected recipes": "احصل على وصول فوري لوصفات مختارة.",
  "Pay once only": "ادفع مرة واحدة فقط",
  "Purchase only what you need": "اشترِ فقط ما تحتاجه.",
  "Start cooking immediately": "ابدأ الطهي فورًا.",
  "Recipe Collection": "مجموعة الوصفات",
  "Choose the perfect recipe plan and start cooking today.": "اختر خطة الوصفات المثالية وابدأ الطهي اليوم.",
  "Unlock a full week of recipe inspiration": "احصل على أسبوع كامل من إلهام الوصفات",
  "Discover fresh recipes every day": "اكتشف وصفات جديدة كل يوم",
  "Enjoy recipes for an entire week": "استمتع بالوصفات لأسبوع كامل.",
  "Explore recipes for one day": "استكشف وصفات ليوم واحد",
  "Choose Pack": "اختر الباقة",
  "Your purchase has been completed successfully": "تمت عملية الشراء بنجاح.",
  "Thank you for choosing": "شكرًا لاختيارك",
  "Click the button below to start enjoying delicious meals delivered directly to your doorstep.": "انقر على الزر أدناه لتبدأ الاستمتاع بوجبات لذيذة تُوصَّل مباشرة إلى باب منزلك.",
  "Click here": "انقر هنا",
  "Click the button below to start exploring delicious recipes and cooking inspiration.": "انقر على الزر أدناه لتبدأ استكشاف وصفات لذيذة وإلهام في الطهي.",
  "Home": "الرئيسية",
  "Categories": "الفئات",
  "Discover, share, and create amazing recipes from around the world.": "اكتشف وشارك وابتكر وصفات رائعة من جميع أنحاء العالم.",
  "All rights reserved.": "جميع الحقوق محفوظة.",
  "steps": "خطوات",
  "About Us": "من نحن",
  "Submit Recipe": "أرسل وصفة",
  "My Profile": "ملفي الشخصي",
  "Share Your Recipe": "شارك وصفتك",
  "Fill in the details below to publish your recipe to the community": "املأ التفاصيل أدناه لنشر وصفتك للمجتمع.",
  "New Recipe": "وصفة جديدة",
  "Recipe Photo": "صورة الوصفة",
  "Video URL (optional)": "رابط الفيديو (اختياري)",
  "Basic Info": "معلومات أساسية",
  "Recipe Name": "اسم الوصفة",
  "Description": "الوصف",
  "Category": "الفئة",
  "Time & Servings": "الوقت والحصص",
  "Prep Time (min)": "وقت التحضير (دقيقة)",
  "Cook Time (min)": "وقت الطهي (دقيقة)",
  "Servings": "عدد الحصص",
  "Classification": "التصنيف",
  "Click to upload a photo": "انقر لتحميل صورة",
  "Difficulty": "مستوى الصعوبة",
  "Easy": "سهل",
  "Medium": "متوسط",
  "Hard": "صعب",
  "Meal Type": "نوع الوجبة",
  "Breakfast": "فطور",
  "Lunch": "غداء",
  "Dinner": "عشاء",
  "Snack": "وجبة خفيفة",
  "Dessert": "حلوى",
  "Diet Type": "نوع النظام الغذائي",
  "Veg": "نباتي",
  "Non Veg": "غير نباتي",
  "Vegan": "نباتي صرف",
  "Keto": "كيتو",
  "Low Carb": "قليل الكربوهيدرات",
  "High Protein": "غني بالبروتين",
  "Ingredient": "المكون",
  "e.g. chicken breast": "مثال: صدر دجاج",
  "Quantity": "الكمية",
  "e.g. 2 cups": "مثال: كوبان",
  "Add Ingredient": "أضف مكونًا",
  "Preparation Steps": "خطوات التحضير",
  "Step 1: describe what to do...": "الخطوة 1: صف ما يجب فعله...",
  "Add Step": "أضف خطوة",
  "Publishing": "النشر",
  "Feature this recipe": "إبراز هذه الوصفة",
  "Featured recipes appear on the homepage": "تظهر الوصفات المميزة في الصفحة الرئيسية",
  "Status": "الحالة",
  "Active — visible to everyone": "نشط — مرئي للجميع",
  "Inactive — hidden from listing": "غير نشط — مخفي من القائمة",
  "Publish Recipe": "انشر الوصفة",
  "All rights reserved": "جميع الحقوق محفوظة",
  "Cancel": "إلغاء",
  "Yes, Deactivate": "نعم، قم بالتعطيل",
  "Deactivating...": "جارٍ التعطيل...",
  "This will deactivate your account and you'll lose access until you resubscribe. This action cannot be undone": "سيؤدي هذا إلى تعطيل حسابك وستفقد الوصول إليه حتى تشترك مجددًا. لا يمكن التراجع عن هذا الإجراء.",
  "Deactivate Account": "تعطيل الحساب",
  "Your Name": "اسمك",
  "Some Error Occured While Deactivation!!": "حدث خطأ أثناء التعطيل!!",
  "User Deactivated Successfully!!": "تم تعطيل المستخدم بنجاح!!",
  "subscribing...": "جارٍ الاشتراك...",
  "Please top up your account to continue using the service.": "يرجى شحن حسابك لمتابعة استخدام الخدمة.",
  "Payment Failed!!": "فشلت عملية الدفع!!",
  "OTP Verification Failed!!": "فشل التحقق من الرمز!!",
  "Failed to send OTP!!": "فشل إرسال الرمز!!",
  "Wrong Otp Entered!": "تم إدخال رمز خاطئ!",
  "Otp Verified Successfully": "تم التحقق من الرمز بنجاح",
  "Select Category": "اختر الفئة",
  "Share your culinary creations and explore recipes from chefs around the world": "شارك إبداعاتك الطهوية واستكشف وصفات من طهاة حول العالم",
  "Step": "الخطوة",
  "describe what to do": "صف ما يجب فعله",
};

const fr = {
  "select_plan": "Choisissez votre forfait",
  "DISCOVER AMAZING RECIPES": "DECOUVREZ D'INCROYABLES RECETTES",
  "DISCOVER": "DÉCOUVRIR",
  "INCREDIBLE": "D'INCROYABLE",
  "RECIPES": "RECETTES",
  "Share your culinary creations and explore recipes from chefs around the world.": "Partagez vos créations culinaires et découvrez des recettes de chefs du monde entier.",
  "Recipes": "Recettes",
  "recipes": "recettes",
  "Instructions": "Instructions",
  "Ingredients": "Ingrédients",
  "Share Recipe": "Partager la recette",
  "Easy to follow ingredients and cooking instructions.": "Ingrédients et instructions de cuisson faciles à suivre.",
  "recipes available": "recettes disponibles",
  "Browse by Category": "Parcourir par catégorie",
  "Avg. Cook Time": "Temps moyen de préparation",
  "Discover Incredible Recipes": "Découvrez d'incroyables recettes",
  "User Rating": "Note des utilisateurs",
  "Enter your mobile number (MSISDN)": "Entrez votre numéro de mobile (MSISDN)",
  "Enter exactly 9 digits (e.g. 650123456)": "Saisissez exactement 9 chiffres (ex. : 650123456)",
  "SUBSCRIBE": "S’ABONNER",
  "By subscribing, you agree to our": "En vous abonnant, vous acceptez nos",
  "Terms & Conditions": "conditions générales",
  "Step-by-Step Instructions": "Instructions étape par étape",
  "Save Your Favorites": "Enregistrez vos favoris",
  "Smart Grocery List": "Liste de courses intelligente",
  "Delicious starts here": "Le plaisir commence ici",
  "Enter 9 digit number": "Entrez un numéro à 9 chiffres",
  "Please enter a valid 9-digit Cameroon mobile number.": "Veuillez saisir un numéro de mobile camerounais valide à 9 chiffres.",
  "Verify Your Number": "Vérifiez votre numéro",
  "Enter the verification code sent to your mobile number": "Saisissez le code de vérification envoyé à votre numéro de mobile.",
  "One-Time Password (OTP)": "Mot de passe à usage unique (OTP)",
  "Verify & Proceed": "Vérifier et continuer",
  "Didn't receive the code?": "Vous n’avez pas reçu le code ?",
  "Resend available in": "Nouvel envoi disponible dans",
  "Resend OTP": "Renvoyer l’OTP",
  "Back": "Retour",
  "STEP 1 OF 2": "ÉTAPE 1 SUR 2",
  "Your Perfect Meal Starts Here": "Votre repas parfait commence ici",
  "Choose between a recurring meal plan or a one-time food order. Fresh, delicious meals delivered to your doorstep.": "Choisissez entre un abonnement de repas récurrent ou une commande ponctuelle. Des repas frais et délicieux livrés directement à votre porte.",
  "Your Number": "Votre numéro",
  "OTP": "OTP",
  "Pack Type": "Type de pack",
  "Choose Plan": "Choisir un forfait",
  "SUBSCRIPTION PACKS (MOST POPULAR)": "PACKS D’ABONNEMENT (LE PLUS POPULAIRE)",
  "Daily fresh meals delivered automatically": "Des repas frais livrés automatiquement chaque jour",
  "Auto Renewal": "Renouvellement automatique",
  "Hassle-free and convenient": "Simple et pratique",
  "Better Value": "Meilleur rapport qualité-prix",
  "Save more with every plan": "Économisez davantage avec chaque abonnement",
  "Never Miss a Meal": "Ne manquez jamais un repas",
  "Meals delivered on your schedule": "Repas livrés selon votre planning",
  "OR": "OU",
  "ONE-TIME ORDER": "COMMANDE PONCTUELLE",
  "Order whenever you want": "Commandez quand vous le souhaitez",
  "No Commitment": "Sans engagement",
  "Pay only when you order": "Payez uniquement lorsque vous commandez",
  "Instant Purchase": "Achat instantané",
  "Quick and easy checkout": "Paiement rapide et facile",
  "Flexible Choice": "Choix flexible",
  "Order what you want, when you want": "Commandez ce que vous voulez, quand vous voulez",
  "Continue": "Continuer",
  "SUBSCRIPTION PACKS": "FORMULES D’ABONNEMENT",
  "Your": "Votre",
  "Perfect Meal": "repas idéal",
  "Starts Here": "commence ici",
  "MOST POPULAR": "LES PLUS POPULAIRES",
  "ONE-TIME PURCHASE OFFER": "OFFRE D’ACHAT UNIQUE",
  "Choose Your Perfect Meal Pack ": "Choisissez votre pack repas idéal",
  "Select the pack size and serving amount that best fits your recurring meal needs.": "Sélectionnez la taille du pack et la quantité de portions qui correspondent le mieux à vos besoins en repas récurrents.",
  "DAILY PLAN": "FORFAIT QUOTIDIEN",
  "UVFOODBOX / Day": "UVFOODBOX / jour",
  "day": "jour",
  "Perfect for daily meal enjoyment": "Parfait pour profiter de repas frais chaque jour",
  "Select Plan": "Sélectionner le forfait",
  "WEEKLY PLAN": "FORFAIT HEBDOMADAIRE",
  "UVFOODBOX / Week": "UVFOODBOX / Semaine",
  "week": "semaine",
  "Best value for the week": "Le meilleur rapport qualité-prix pour la semaine",
  "Choose Your": "Choisissez votre",
  "Perfect Meal Pack": "Pack repas idéal",
  "Select the pack size and serving amount that best fits your": "Sélectionnez la taille du paquet et la quantité par portion qui correspondent le mieux à vos",
  "recurring meal": "repas récurrent",
  "one-time order": "commande ponctuelle",
  "XAF / day": "XAF / jour",
  "XAF / week": "XAF / semaine",
  "STEP 2 OF 2": "ÉTAPE 2 SUR 2",
  "Verify OTP": "Vérifier le code OTP",
  "Discover Delicious": "Découvrez le délicieux",
  "Unlock delicious recipes, cooking tips, and meal ideas to inspire your next dish.": "Découvrez de délicieuses recettes, des astuces de cuisine et des idées de repas pour inspirer votre prochain plat.",
  "Unlimited access to premium recipes": "Accès illimité aux recettes premium",
  "Unlimited Recipes": "Recettes illimitées",
  "Access our complete recipe collection": "Accédez à notre collection complète de recettes",
  "Learn techniques from expert chefs": "Apprenez des techniques auprès de chefs experts",
  "Premium Cooking Tips": "Conseils culinaires premium",
  "Get instant access to selected recipes": "Accédez instantanément à une sélection de recettes.",
  "Pay once only": "Payez une seule fois",
  "Purchase only what you need": "Achetez uniquement ce dont vous avez besoin",
  "Start cooking immediately": "Commencez à cuisiner immédiatement",
  "Recipe Collection": "Collection de recettes",
  "Choose the perfect recipe plan and start cooking today.": "Choisissez la formule de recettes idéale et commencez à cuisiner dès aujourd'hui.",
  "Unlock a full week of recipe inspiration": "Découvrez une semaine entière d'inspiration culinaire",
  "Discover fresh recipes every day": "Découvrez de nouvelles recettes chaque jour",
  "Enjoy recipes for an entire week": "Profitez de recettes pour toute une semaine.",
  "Explore recipes for one day": "Découvrez des recettes pour une journée",
  "Choose Pack": "Choisir un pack",
  "Your purchase has been completed successfully": "Votre achat a été effectué avec succès.",
  "Thank you for choosing": "Merci d'avoir choisi",
  "Click the button below to start enjoying delicious meals delivered directly to your doorstep.": "Cliquez sur le bouton ci-dessous pour commencer à profiter de délicieux repas livrés directement à votre porte.",
  "Click here": "Cliquez ici",
  "Click the button below to start exploring delicious recipes and cooking inspiration.": "Cliquez sur le bouton ci-dessous pour commencer à découvrir de délicieuses recettes et trouver l'inspiration en cuisine.",
  "Home": "Accueil",
  "Categories": "Catégories",
  "Discover, share, and create amazing recipes from around the world.": "Découvrez, partagez et créez des recettes incroyables venues du monde entier.",
  "All rights reserved.": "Tous droits réservés.",
  "steps": "étapes",
  "About Us": "À propos de nous",
  "Submit Recipe": "Soumettre une recette",
  "My Profile": "Mon profil",
  "Share Your Recipe": "Partagez votre recette",
  "Fill in the details below to publish your recipe to the community": "Remplissez les informations ci-dessous pour publier votre recette auprès de la communauté.",
  "New Recipe": "Nouvelle recette",
  "Recipe Photo": "Photo de la recette",
  "Video URL (optional)": "URL de la vidéo (facultatif)",
  "Basic Info": "Informations de base",
  "Recipe Name": "Nom de la recette",
  "Description": "Description",
  "Category": "Catégorie",
  "Time & Servings": "Temps et portions",
  "Prep Time (min)": "Temps de préparation (min)",
  "Cook Time (min)": "Temps de cuisson (min)",
  "Servings": "Portions",
  "Classification": "Classification",
  "Click to upload a photo": "Cliquez pour télécharger une photo",
  "Difficulty": "Difficulté",
  "Easy": "Facile",
  "Medium": "Moyen",
  "Hard": "Difficile",
  "Meal Type": "Type de repas",
  "Breakfast": "Petit-déjeuner",
  "Lunch": "Déjeuner",
  "Dinner": "Dîner",
  "Snack": "En-cas",
  "Dessert": "Dessert",
  "Diet Type": "Type de régime",
  "Veg": "Végétarien",
  "Non Veg": "Non végétarien",
  "Vegan": "Végétalien",
  "Keto": "Cétogène",
  "Low Carb": "Faible en glucides",
  "High Protein": "Riche en protéines",
  "Ingredient": "Ingrédient",
  "e.g. chicken breast": "ex. : blanc de poulet",
  "Quantity": "Quantité",
  "e.g. 2 cups": "ex. : 2 tasses",
  "Add Ingredient": "Ajouter un ingrédient",
  "Preparation Steps": "Étapes de préparation",
  "Step 1: describe what to do...": "Étape 1 : décrivez ce qu'il faut faire...",
  "Add Step": "Ajouter une étape",
  "Publishing": "Publication",
  "Feature this recipe": "Mettre cette recette en avant",
  "Featured recipes appear on the homepage": "Les recettes mises en avant apparaissent sur la page d'accueil",
  "Status": "Statut",
  "Active — visible to everyone": "Actif — visible par tous",
  "Inactive — hidden from listing": "Inactif — masqué dans la liste",
  "Publish Recipe": "Publier la recette",
  "All rights reserved": "Tous droits réservés",
  "Cancel": "Annuler",
  "Yes, Deactivate": "Oui, désactiver",
  "Deactivating...": "Désactivation en cours...",
  "This will deactivate your account and you'll lose access until you resubscribe. This action cannot be undone": "Cela désactivera votre compte et vous en perdrez l'accès jusqu'à ce que vous vous réabonniez. Cette action est irréversible.",
  "Deactivate Account": "Désactiver le compte",
  "Your Name": "Votre nom",
  "Some Error Occured While Deactivation!!": "Une erreur s'est produite lors de la désactivation !!",
  "User Deactivated Successfully!!": "Utilisateur désactivé avec succès !!",
  "subscribing...": "s'abonner...",
  "Please top up your account to continue using the service.": "Veuillez recharger votre compte pour continuer à utiliser le service.",
  "Payment Failed!!": "Échec du paiement !!",
  "OTP Verification Failed!!": "Échec de la vérification du code OTP !!",
  "Failed to send OTP!!": "Échec de l'envoi du code OTP !!",
  "Wrong Otp Entered!": "Code OTP incorrect !",
  "Otp Verified Successfully": "OTP vérifié avec succès",
  "Select Category": "Sélectionner une catégorie",
  "Share your culinary creations and explore recipes from chefs around the world": "Partagez vos créations culinaires et découvrez des recettes de chefs du monde entier",
  "Step": "Étape",
  "describe what to do": "décrivez ce qu'il faut faire",
};

export const translations = { ar, fr };

// purana code (agar kahin `arr` import ho raha ho) na tootne ke liye:
export const arr = ar;